module.exports = __webpack_public_path__ + "static/img/inverted-ramp-8m-x-2m_256.0e4fed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inverted-ramp-8m-x-2m_256.png
// module id = 8OO6
// module chunks = 0